var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pageBox" },
        [
          _c(
            "div",
            { staticClass: "breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v("首页"),
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("考勤异常申诉")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pageSerch" },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "cardTitle" }, [
                        _vm._v("考勤异常申诉"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务编号" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      clearable: "",
                                      placeholder: "请输入任务编号",
                                    },
                                    model: {
                                      value: _vm.ruleForm.jobNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "jobNo", $$v)
                                      },
                                      expression: "ruleForm.jobNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "申诉姓名" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      clearable: "",
                                      placeholder: "请输入申诉姓名",
                                    },
                                    model: {
                                      value: _vm.ruleForm.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "name", $$v)
                                      },
                                      expression: "ruleForm.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "申诉手机号" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      clearable: "",
                                      placeholder: "请输入申诉手机号",
                                    },
                                    model: {
                                      value: _vm.ruleForm.phone,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "phone", $$v)
                                      },
                                      expression: "ruleForm.phone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "状态" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-right": "auto" },
                                      attrs: { placeholder: "请选择状态" },
                                      model: {
                                        value: _vm.ruleForm.status,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "status", $$v)
                                        },
                                        expression: "ruleForm.status",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "待审核", value: "0" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "审核通过",
                                          value: "1",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "审核拒绝",
                                          value: "2",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getList()
                                        },
                                      },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.resetForm()
                                        },
                                      },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("TableScrollSlider", {
            attrs: { "table-ref": _vm.$refs.multipleTable },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pageTab" },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%", "margin-top": "20px" },
                  attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "appealNo",
                      label: "编号",
                      align: "center",
                      width: "200",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "appealName",
                      label: "申诉人",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "任务名称", align: "center", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-popover",
                              { attrs: { trigger: "hover", placement: "top" } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.jobTitle) +
                                    "\n              "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "name-wrapper",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _c("div", { staticClass: "omit" }, [
                                      _vm._v(_vm._s(scope.row.jobTitle)),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "考勤日期", align: "center", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.startDate))]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(scope.row.endDate))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "打卡时间", align: "center", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.startTime))]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(scope.row.endTime))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "打卡状态", align: "center", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.signStatus == 0
                              ? _c("span", [_vm._v("未打卡")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.signStatus == 1
                              ? _c("span", [_vm._v("正常打卡")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.signStatus == -1
                              ? _c("span", [_vm._v("迟到打卡")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.signStatus == -2
                              ? _c("span", [_vm._v("早退打卡")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.signStatus == -3
                              ? _c("span", [_vm._v("旷工")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "审核人", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.operatorName)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", align: "center", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.operateStatus == 0
                              ? _c("span", { staticClass: "blueColor" }, [
                                  _vm._v("待审核"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.operateStatus == 1
                              ? _c("span", { staticClass: "greenColor" }, [
                                  _vm._v("审核通过"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.operateStatus == 2
                              ? _c("span", { staticClass: "redColor" }, [
                                  _vm._v("审核拒绝"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "创建时间", align: "center", width: "190" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.gmtCreate))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "处理时间", align: "center", width: "190" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.operateAt))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      align: "center",
                      fixed: "right",
                      width: "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "disAround" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "operateBtn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.goDetail(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("详情")]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.pageSize,
                  layout: "total, prev, pager, next,sizes",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }